import { Temporal } from '@js-temporal/polyfill'
import type { ComputedRef, Ref } from 'vue'

export const useTemporalPlainTime = (item: Ref<string>): ComputedRef<Temporal.PlainTime> => {
  return computed(() => Temporal.PlainTime.from(item.value))
}
